import { decryptAES, encryptAES } from "../../Common/Axios/encrypt";
import API from "../../Common/Endpoint/serviceConstrants";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import { onPostEarnPointSubmit } from "../../Store/Slices/earnPointSlice";
import { onGenerateTokenSubmit } from "../../Store/Slices/generateTokenSlice";
import { onGetMember } from "../../Store/Slices/getMemberSlice";
import { onPostRedeemPoints } from "../../Store/Slices/redeemPointsSlice";
import { onPostSendMail } from "../../Store/Slices/sendMailSlice";
import {
  onAllSmsSentSuccess,
  onPostSendSmsSubmit,
} from "../../Store/Slices/sendSmsSlice";
import { onPostSwitchAccount } from "../../Store/Slices/switchAccountSlice";
import { onPostUrlData } from "../../Store/Slices/urlStoreSlice";
import { onPostVendorOrder } from "../../Store/Slices/vendorOrderSlice";
import {
  ClientConfigurationData,
  formatPrice,
  GetCurrentDateTime,
  getImageUrl,
  ParseInt,
} from "../Utility/Utility";

const handleGenerateToken = (dispatch, v3Data) => {
  dispatch(
    onGenerateTokenSubmit({
      accessKey: v3Data?.accessKey,
      secrateKey: v3Data?.secrateKey,
      partnerCode: v3Data?.partnerCode,
      ClientCode: v3Data?.ClientCode,
    }),
  );
};
const handleGetMember = (dispatch, loginV3Data, v3Data) => {
  dispatch(
    onGetMember({
      memberIdentifier: loginV3Data?.memberIdentifier,
      ClientCode: v3Data?.ClientCode,
      partnerCode: v3Data?.partnerCode,
    }),
  );
};

const callSwitchAccountApi = (dispatch, loginToken, v3Data) => {
  const switchPayload = {
    identifier: loginToken?.memberIdentifier,
    subIdentifier: loginToken?.subIdentifier || "",
    identifierType: 1001,
    userSessionToken: sessionStorage.getItem("loginSessionToken"),
    isAccountSwitch: false,
    ClientCode: v3Data?.ClientCode,
    partnerCode: v3Data?.partnerCode,
  };
  dispatch(onPostSwitchAccount(switchPayload));
};

const handlePointsUpdate = (dispatch, memberData) => {
  dispatch(
    onSavePoints({
      pointBalance: memberData?.pointBalance,
    }),
  );
};

const handleVedorOrder = (dispatch, payload) => {
  dispatch(onPostVendorOrder(payload));
};

const handleShortURL = (dispatch, orderData, memberData, productList) => {
  productList.forEach((prod) => {
    var enc = encryptAES(
      `email=true&orderId=${orderData?.postOrderData?.[0]?.orderNumber}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
    );
    var finalUrl = `${window.location.origin}/${ClientConfigurationData?.otpRedeem ? "otp" : "order-detail"
      }?${enc}`;
    dispatch(
      onPostUrlData({
        longUrl: finalUrl,
        otp: enc,
        orderId: orderData?.postOrderData?.[0]?.orderNumber,
        denomination: prod.denomination,
      }),
    );
  });
};

const handleSendSms = (
  dispatch,
  orderDetails,
  loginV3Data,
  V3Data,
  cardName,
  smsTemplate,
  orderData,
) => {
  if (!smsTemplate?.smsBody) return;

  if (orderDetails?.length) {
    for (var o = 0; o < orderDetails.length; o++) {
      const giftCode = orderDetails[o]?.giftCode
        ? decryptAES(orderDetails[o]?.giftCode)
        : [];

      // Prepare base template once per order
      var baseTemplate = smsTemplate.smsBody;

      baseTemplate = baseTemplate?.replace(
        "{%memberName%}",
        `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""}`,
      );

      baseTemplate = baseTemplate?.replace(
        "{%orderId%}",
        orderData?.orderId || "",
      );

      baseTemplate = baseTemplate?.replace("{%voucherName%}", cardName || "");

      // Use FOR loop as you want
      for (var i = 0; i < giftCode.length; i++) {
        var dynamicdata = baseTemplate;

        dynamicdata = dynamicdata?.replace(
          "{%voucherValue%}",
          formatPrice(giftCode[i]?.Amount),
        );

        dynamicdata = dynamicdata?.replace(
          "{%voucherDate%}",
          new Date(giftCode[i]?.Validity)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })?.replace(/ /g, " "),
        );

        var pinLabel = giftCode[i]?.labels?.cardPin;
        var numberLabel = giftCode[i]?.labels?.cardNumber;

        const cardNumber = giftCode[i]?.CardNumber
          ? `\n${numberLabel} ${giftCode[i].CardNumber}`
          : "";

        const cardPin = giftCode[i]?.CardPin
          ? `\n${pinLabel} ${giftCode[i].CardPin}`
          : "";

        dynamicdata = dynamicdata?.replace("{%voucherPin%}", cardPin || "");
        dynamicdata = dynamicdata?.replace("{%voucherCode%}", cardNumber || "");

        const payload = {
          ClientCode: V3Data?.ClientCode,
          partnerCode: V3Data?.partnerCode,
          templateCode: smsTemplate?.tempCode,
          toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
          contentValue: {
            additionalProp1: "string",
          },
          content: dynamicdata,
        };

        dispatch(onPostSendSmsSubmit(payload));
      }
    }
  } else {
    const giftCode = orderDetails?.giftCode
      ? decryptAES(orderDetails?.giftCode)
      : [];

    // Same logic for single order
    var baseTemplate = smsTemplate.smsBody;

    baseTemplate = baseTemplate?.replace(
      "{%memberName%}",
      `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""}`,
    );

    baseTemplate = baseTemplate?.replace(
      "{%orderId%}",
      orderData?.orderId || "",
    );

    baseTemplate = baseTemplate?.replace("{%voucherName%}", cardName || "");

    for (var i = 0; i < giftCode?.length; i++) {
      var dynamicdata = baseTemplate;

      dynamicdata = dynamicdata?.replace(
        "{%voucherValue%}",
        formatPrice(giftCode[i]?.Amount),
      );

      dynamicdata = dynamicdata?.replace(
        "{%voucherDate%}",
        new Date(giftCode[i]?.Validity)
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, " "),
      );

      var pinLabel = giftCode[i]?.labels?.cardPin;
      var numberLabel = giftCode[i]?.labels?.cardNumber;

      const cardNumber = giftCode[i]?.CardNumber
        ? `\n${numberLabel} ${giftCode[i].CardNumber}`
        : "";

      const cardPin = giftCode[i]?.CardPin
        ? `\n${pinLabel} ${giftCode[i].CardPin}`
        : "";

      dynamicdata = dynamicdata?.replace("{%voucherPin%}", cardPin || "");
      dynamicdata = dynamicdata?.replace("{%voucherCode%}", cardNumber || "");

      const payload = {
        ClientCode: V3Data?.ClientCode,
        partnerCode: V3Data?.partnerCode,
        templateCode: smsTemplate?.tempCode,
        toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
        contentValue: {
          additionalProp1: "string",
        },
        content: dynamicdata,
      };

      dispatch(onPostSendSmsSubmit(payload));
    }
  }
};

function getTNCById(id, type = "tncContent", clientProduct) {
  const item = clientProduct?.find((entry) => entry.id === id);
  return item ? item[type] : null;
}
const replacePlaceholders = (template, replacements) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => replacements[key]);
};
const cleanHTML = (htmlString) => {
  return htmlString?.replace(/\s+/g, " ")?.replace(/"/g, "'")?.trim();
};

const shortUrlSendSms = async (
  dispatch,
  productList,
  orderData,
  memberData,
  clientConfig,
  axiosInstanceClient,
  v3Data,
  loginV3Data,
  productReducer,
  navigate,
  setLoading,
) => {
  setLoading(true);
  try {
    const responses = await Promise.allSettled(
      productList.map(async (prod) => {
        const enc = encryptAES(
          `email=true&orderId=${orderData?.postOrderData?.[0]?.orderid}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
        );

        const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
          }?${enc}`;

        const payload = {
          longUrl,
          otp: enc,
          orderId: orderData?.postOrderData?.[0]?.orderNumber,
          denomination: prod.denomination,
        };

        const response = await axiosInstanceClient.post(API.manageUrl, payload);

        return {
          ...prod,
          shortUrl: response.data?.response?.[0]?.shortUrl || longUrl,
          fallbackUrl: longUrl,
        };
      }),
    );

    responses.forEach((result, index) => {
      const prod = productList[index];
      const enc = encryptAES(
        `email=true&orderId=${orderData?.postOrderData?.[0]?.orderId}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
      );

      const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
        }?${enc}`;

      const url =
        result.status === "fulfilled"
          ? result.value.shortUrl || longUrl
          : longUrl;

      const payload = {
        ClientCode: v3Data?.ClientCode,
        partnerCode: v3Data?.partnerCode,
        templateCode: "BOMORDCONF01 ",
        toMobileNumber: loginV3Data.mobileNumber,
        contentValue: null,
        content: `Congrats! You’ve ordered ${prod.quantity} ${productReducer?.productReducer?.[0]?.name} worth ₹${prod.denomination} from Bank of Maharashtra Giftstacc! Access here: ${url}. T&C: https://bankofmaharashtra.giftstacc.com/listing – CustCap`,
      };

      dispatch(onPostSendSmsSubmit(payload));
    });
  } catch (error) {
    console.error("Unexpected error during manageUrl execution:", error);
  } finally {
    dispatch(onAllSmsSentSuccess());
    navigate("/order-confirmation");
  }
};
export {
  handleGenerateToken,
  handleGetMember,
  handlePointsUpdate,
  handleSendSms,
  handleVedorOrder,
  handleShortURL,
  shortUrlSendSms,
  callSwitchAccountApi
};
